import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PRD_MRE_REG_001_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    const [popupParent, setPopupParent] = useState<any>(null);
    const [doubleData, setDoubleData] = useState<any[]>();
    const [initFlag, setInitFlag] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const checkedRows =
          doubleData && doubleData.length > 0
            ? doubleData
            : gridRefs.current["grid1"].current?.getSelectedRows() || [];

        return { flag: true };
      },
      getSelectedRow: () => {
        if (doubleData && doubleData.length > 0) {
          return [doubleData];
        }
        return [gridRefs.current["grid1"].current?.getSelectedRows() || []];
      },
      getOkayData: () => {
        return {
          rtnData: [gridRefs.current["grid1"].current?.getSelectedRows() || []],
        };
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_MRE_REG_001_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
          });
          setInitFlag(true);
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_prd_mre_reg_001_pop_01",
          params: searchRef.current.getFormdata(),
        };
        gridRefs.current["grid1"].current.resetUpdate();

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
        });
      } catch (error: any) {}
    };

    const onCellDoubleClicked = (e: any) => {
      console.log(e);
      let returnData: any[] =
        gridRefs.current["grid1"].current?.getCheckedRows();
      const exists = returnData.some((data) => data.no_mre === e.data.no_mre);
      if (!exists) returnData.push(e.data);
      setDoubleData(returnData);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCellDoubleClicked: onCellDoubleClicked,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "multiple",
              popupParent: popupParent,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_PRD_MRE_REG_001_POP_01;
